import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';

export interface TenantResponse {
  id: number;
  uuid: string;
  name: string;
  slug: string;
  logo_url?: string;
  favicon_url?: string;
  created_at?: string;
  updated_at?: string;
}

export interface AllTenantsResponse {
  success: boolean;
  message: string;
  data: {
    tenants: TenantResponse[];
    total: number;
  };
}

export const getAllTenants = async (): Promise<AllTenantsResponse> => {
  const response = await axiosInstance.get<AllTenantsResponse>(`${env.apiTasklistBaseUrl}/api/v1/compro/all-tenants`);
  return response.data;
};
